export default __webpack_public_path__ + "static/media/screen7.cfa7a1fb.png";